export default __webpack_public_path__ + "static/media/yt.180fec80.svg";